<template>
  <div class="menu-layout-container">
    <el-header class="header_wrapper common_bg" height="60px">
      <div class="header_left">
        <!--div style=" font-size: 16pt; ">观天 · 快搜</div-->
        <img class="logo" :src="logo" @click="goHome" style="height: 35px; margin-top: 2px;" />
      </div>
      <div class="header_right">
        <div :class="validateWarn ? 'Validate2' : 'Validate1'" v-if="user">服务期至：{{user.limitDate}}</div>
        <ul class="header_nav">
          <li
            class="header_nav_item"
            v-for="(item, index) in navList"
            :key="item.name"
            :class="{
              undisable: !item.hasPermission,
              active: activeIndex == item.path
            }"
            @click="toUrl(item, index)"
          >
            {{ item.text }}
          </li>
        </ul>
        <div class="login-txt" v-if="!user" @click="handleLoginClick">
          登录
        </div>
        <el-dropdown
          class="login-info"
          trigger="hover"
          v-else
          @command="handleCommand"
        >
          <span class="el-dropdown-link name" style="display: flex;align-items: center;justify-content: center">
            <img :src="userImage" style="width: 20px;height: 20px;"/>
            <span style="padding:0 8px;">{{ user ? user.name : '' }}</span>
            <i class="el-icon-caret-bottom" styel="font-size:16px;"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="change">修改密码</el-dropdown-item>
            <el-dropdown-item command="exit">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </el-header>
    <div class="main-core-content">
      <slot></slot>
    </div>
    <el-dialog
      v-drag:common
      class="login-dialog"
      :modal="false"
      title="登录"
      width="400px"
      :visible="visible"
      :close-on-click-modal="false"
      :before-close="handleCloseClick"
    >
      <el-form
        label-position="right"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
        :model="form"
        class="login-form"
      >
        <el-form-item label="用户名" prop="userCode">
          <el-input
            class="clean-el-input-left text-left"
            v-model="form.userCode"
            @keydown.enter.native="handleLoginSureClick"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            type="password"
            class="clean-el-input-left text-left"
            v-model="form.password"
            @keydown.enter.native="handleLoginSureClick"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-reverse">
        <div class="btn-wrapper">
          <ct-button size="small" :btn-click="handleResetClick">重置</ct-button>
          <ct-button
            size="small"
            type="primary"
            :btn-click="handleLoginSureClick"
            >登录</ct-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-drag:common
      class="login-dialog"
      :modal="false"
      title="修改密码"
      width="400px"
      :visible="changeVisible"
      :before-close="handleChangeCloseClick"
    >
      <el-form
        label-position="right"
        :rules="changeRules"
        ref="changeRuleForm"
        label-width="100px"
        :model="changeForm"
        class="login-form"
      >
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input
            type="password"
            class="clean-el-input"
            v-model="changeForm.oldPassword"
            @keydown.enter.native="handleSureClick"
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            class="clean-el-input"
            type="password"
            v-model="changeForm.newPassword"
            @keydown.enter.native="handleSureClick"
          ></el-input>
        </el-form-item>
        <el-form-item label="确认新密码" prop="newPassword2">
          <el-input
            class="clean-el-input"
            type="password"
            v-model="changeForm.newPassword2"
            @keydown.enter.native="handleSureClick"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-reverse">
        <div class="btn-wrapper">
          <ct-button size="small" :btn-click="handleChangeResetClick"
            >重置</ct-button
          >
          <ct-button size="small" type="primary" :btn-click="handleSureClick"
            >确认</ct-button
          >
        </div>
      </div>
    </el-dialog>

    <el-dialog
      v-drag:common
      class="login-dialog"
      :modal="false"
      title="意见反馈"
      width="450px"
      :visible="feedbackVisible"
      :before-close="handleFeedbackCloseClick"
    >
      <el-form
        label-position="right"
        :rules="feedbackRules"
        ref="feedbackForm"
        label-width="80px"
        :model="feedbackForm"
        class="login-form"
      >
        <el-form-item label="标题" prop="title">
          <el-input
            class="clean-el-input-left text-left"
            v-model="feedbackForm.title"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机" prop="phone">
          <el-input
            class="clean-el-input-left text-left"
            v-model="feedbackForm.phone"
          ></el-input>
        </el-form-item>
        <el-form-item label="内容" prop="content">
          <el-input
            type="textarea"
            :rows="5"
            class="clean-el-input-left text-left"
            v-model="feedbackForm.content"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="flex-reverse">
        <div class="btn-wrapper">
          <ct-button size="small" :btn-click="handleFeedbackResetClick"
            >重置</ct-button
          >
          <ct-button
            size="small"
            type="primary"
            :btn-click="handleFeedbackClick"
            >提交</ct-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 注意此文件会在没有router的环境下使用，请谨慎使用全局router相关的变量
 */
import { mapState } from 'vuex';
import QRcode from '@/asset/qrcode.png';
import { getToken, setToken, safeSetSessionStorage } from '@/utils';
import userImage from '@/asset/user.png';
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.changeForm.newPassword) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      userImage,
      QRcode,
      logo: require('@/asset/banner.png'),
      rules: {
        userCode: [{ required: true, message: '请输入用户名' }],
        password: [{ required: true, message: '请输入密码' }]
      },
      changeRules: {
        newPassword: [{ required: true, message: '请输入新密码' }],
        newPassword2: [
          { required: true, validator: validatePass2, trigger: blur }
        ],
        oldPassword: [{ required: true, message: '请输入旧密码' }]
      },
      feedbackRules: {
        title: [{ required: true, message: '请输入标题' }],
        content: [{ required: true, message: '请输入反馈内容' }]
        //phone: [{type: 'number', message: '手机号必须为数字值'}]
      },
      visible: false,
      changeVisible: false,
      feedbackVisible: false,
      form: {
        userCode: 'dxwind',
        password: ''
      },
      changeForm: {
        newPassword: '',
        newPassword2: '',
        oldPassword: ''
      },
      feedbackForm: {
        title: '',
        content: '',
        phone: ''
      },
      activeIndex: '',
      navList: [
        /*{
          path: '/wind-farm',
          text: '风场规划',
          codes: []
        },
        {
          path: '/public-database/model-data',
          text: '机型库',
          // codes: ['turbineManager', 'powerCurve', 'partManager']
          codes: []
        },
        {
          path: '/wind-data',
          text: '测风数据',
          codes: []
        }*/
      ]
    };
  },
  watch: {
    $route: {
      handler(val, prev) {
        const { name: prevName } = prev;
        const { name = '', query = {} } = val;
        const { callbackUrl = '' } = query;
        this.highLightTab(val);
        if (
          name === 'project-list' &&
          prevName !== 'project-list' &&
          callbackUrl
        ) {
          this.checkLogin().then(res => {
            if (!res) {
              this.handleLoginClick();
            } else {
              this.$router.replace({
                path: callbackUrl
              });
            }
          });
        }
      },
      deep: true
    }
  },
  created() {
    this.highLightTab();
  },
  mounted() {
    this.checkLogin();
  },
  methods: {
    handleChangeResetClick() {
      this.$refs.changeRuleForm.resetFields();
    },
    handleSureClick() {
      this.$refs.changeRuleForm.validate(valid => {
        if (valid) {
          this.$postForm('/windfarm/updateUserPassword', {
            data: {
              ...this.changeForm
            },
            showSuccess: true,
            showError: true
          }).then(() => {
            this.changeVisible = false;
            this.checkLogin();
          });
        }
      });
    },
    handleCommand(command) {
      if (command === 'exit') {
        this.$confirm('是否确认退出', '提醒', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          closeOnClickModal: false
        })
          .then(() => {
            this.$postForm('/windfarm/doLogout', {
              showLoading: true,
              data: {
                apiKey: getToken()
              },
              showError: true,
              showSuccess: true
            }).then(() => {
              setToken('');
              safeSetSessionStorage('selectMenu', '');
              this.$router.push({
                path: '/wind-farm'
              });
              this.$store.commit('SET_USER', null);
            });
          })
          .catch(() => {});
      }

      if (command === 'change') {
        this.changeVisible = true;
      }
    },

    handleFeedbackCloseClick() {
      this.handleFeedbackResetClick();
      this.feedbackVisible = false;
    },
    handleChangeCloseClick() {
      this.handleChangeResetClick();
      this.changeVisible = false;
    },
    handleCloseClick() {
      this.handleResetClick();
      this.visible = false;
    },

    handleLoginSureClick() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$postForm('/windfarm/doLogin', {
            showError: true,
            showSuccess: true,
            showLoading: true,
            data: {
              ...this.form
            }
          }).then(res => {

            const { data = {} } = res;
            console.log(data);
            const { user = {} } = data;
            const { apikey = '' } = user;
            setToken(apikey);
            this.$store.commit('SET_USER', res.data?.user);
            this.handleCloseClick();
            const { callbackUrl = '' } = this.$route.query;

            if (this.$route.name === 'project-list') {
              this.$bus.$emit('updateList');
            }
            if (callbackUrl) {
              this.$router.replace({
                path: callbackUrl
              });
            }
          });
        }
      });
    },

    handleFeedbackClick() {
      this.$refs.feedbackForm.validate(valid => {
        if (valid) {
          this.$postForm('/windfarm/addSuggestionByUser', {
            data: {
              ...this.feedbackForm
            },
            showSuccess: true,
            showError: true
          }).then(() => {
            this.feedbackVisible = false;
          });
        }
      });
    },

    handleResetClick() {
      this.$refs.ruleForm.resetFields();
    },

    handleFeedbackResetClick() {
      this.$refs.feedbackForm.resetFields();
    },

    handleLoginClick() {
      this.visible = true;
    },

    handleShowFeedbackClick() {
      this.feedbackVisible = true;
    },

    checkLogin() {
      return this.$postForm('/windfarm/checkLogin', {
        showError: true
      }).then(res => {
        const { data, code = '' } = res || {};
        if (code === 0) {
          this.$store.commit('SET_USER', data?.user);
          return true;
        }
        this.$store.commit('SET_USER', null);
        return false;
      });
    },

    toUrl: function(item) {
      let apiKey = localStorage.getItem('apiKey');
      if (!apiKey) {
        this.handleLoginClick();
        return;
      }
      let { path } = item;
      this.activeIndex = path;
      if (!this.$route) {
        if (location.pathname === path) return;
        location.href = `/#${path}`;
        return;
      }
      if (path === this.$route.path) return;
      if (path === '/flow.html') {
        // flow 是另一个html页面，不是单页
        location.href = path;
      } else {
        this.$router.push(path);
      }
    },
    goHome() {
      if (!this.$route) {
        location.href = `/`;
        return;
      }
      this.$router.push('/');
    },
    highLightTab(route) {
      let { path } = route || this.$route || {};
      if (!path) {
        path = '/wind-farm';
      }
      const item = this.navList.find(v => path.indexOf(v.path) !== -1);
      if (item) {
        this.activeIndex = item.path;
      }
    }
  },
  computed: {
    ...mapState(['user']),
    isRoot() {
      return this.$route && this.$route.name === 'root';
    },
    validateWarn(){
      if(this.user){
        // const limitDate = '2024-10-2';
        // let diff = new Date(limitDate) - new Date();
        let diff = new Date(this.user.limitDate) - new Date();
        let months = diff / (1000 * 60 * 60 * 24 * 30);
        // const ic = Math.abs(months);
        // console.log(months);
        // console.log(parseInt(ic));
        if(months < 2){
          return true;
        }else{
          return false;
        }
      }else{
        return false;
      }
    }
  }
};
</script>
<style lang="less" scoped>
.menu-layout-container {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  .main-core-content {
    height: 100%;
    width: 100%;
    overflow: hidden;
  }
}
// .login-form {
//   width: 350px;
//   margin: 0 auto;
// }
.login-txt {
  padding-left: 20px;
  cursor: pointer;
}
.login-info {
  padding-left: 20px;
  .name {
    cursor: pointer;
    .icontouxiang {
      font-size: 30px;
      margin-right: 5px;
      color: rgb(139, 155, 174);
    }
    i {
      vertical-align: middle;
    }
  }
}
.btn-wrapper {
  span:first-child {
    margin-right: 10px;
  }
}
.header {
  &_wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &_right {
    display: flex;
    align-items: center;
  }
  &_nav {
    display: flex;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(68, 68, 68, 1);
    padding-right: 30px;
    border-right: 1px solid rgba(67, 67, 67, 0.3);
    &_item {
      padding: 10px 25px;
      cursor: pointer;
      &.active {
        color: @white-color;
        background: linear-gradient(to right, #0878bfff 0%, #0056aaff 100%);
        border-radius: 8px;
      }
    }
  }
}
.Validate1 {
  color: green;
  font-size: 12px;
}
.Validate2 {
  color: red;
  font-size: 12px;
}
</style>
